import React, { useState, useEffect } from "react";
import { getBusinesses } from "../utils/api";
import BusinessCard from "../components/BusinessCard";
import { Search, Sparkles, Calendar } from "lucide-react";

export default function Home() {
  const [businesses, setBusinesses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchBusinesses() {
      try {
        setLoading(true);
        const data = await getBusinesses();
        setBusinesses(data);
      } catch (err) {
        setError("İşletmeler yüklenirken bir hata oluştu.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchBusinesses();
  }, []);

  const categories = ["ALL", ...new Set(businesses.map((b) => b.category))];

  const filtered = businesses.filter((b) => {
    const matchesSearch =
      b.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      b.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === "ALL" || b.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg" />
        <div className="hero-pattern" />

        <div className="hero-content">
          <div className="hero-badge">
            <Sparkles />
            Hızlı ve kolay randevu sistemi
          </div>
          <h1 className="hero-title">
            Randevun Her Zaman{" "}
            <span className="hero-title-highlight">Hazır</span>
          </h1>
          <p className="hero-subtitle">
            İstediğin işletmeden, istediğin zaman online randevu al. Sıra
            bekleme devri bitti!
          </p>

        </div>

        {/* Wave Divider */}
        <div className="hero-wave">
          <svg viewBox="0 0 1440 80" fill="none">
            <path
              d="M0,32L48,37.3C96,43,192,53,288,53.3C384,53,480,43,576,37.3C672,32,768,32,864,37.3C960,43,1056,53,1152,53.3C1248,53,1344,43,1392,37.3L1440,32L1440,80L1392,80C1344,80,1248,80,1152,80C1056,80,960,80,864,80C768,80,672,80,576,80C480,80,384,80,288,80C192,80,96,80,48,80L0,80Z"
              fill="#f8fafc"
            />
          </svg>
        </div>
      </section>

      {/* Category Filter & Business Grid */}
      <section className="section-container">
        {/* Stats banner */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon purple"> {/*blue*/}
              <Calendar />
            </div>
            <p className="stat-value">{businesses.length}</p>
            <p className="stat-label">Kayıtlı İşletme</p>
          </div>
          <div className="stat-card">
            <div className="stat-icon purple">
              <Sparkles />
            </div>
            <p className="stat-value">24/7</p>
            <p className="stat-label">Online Randevu</p>
          </div>
          <div className="stat-card">
            <div className="stat-icon purple"> {/*orange*/}
              <Search />
            </div>
            <p className="stat-value">Kolay</p>
            <p className="stat-label">Hızlı Arama</p>
          </div>
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="center-screen" style={{ minHeight: "200px" }}>
            <div className="spinner" />
            <p style={{ marginTop: "1rem", color: "#94a3b8" }}>Yükleniyor...</p>
          </div>
        ) : error ? (
          <div className="empty-state">
            <p style={{ color: "#ef4444" }}>{error}</p>
          </div>
        ) : (
          <>
            {/* Filter and Search Container */}
            <div className="filter-search-container">
              {/* Category Filter */}
              <div className="category-filter">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    onClick={() => setSelectedCategory(cat)}
                    className={`category-btn ${selectedCategory === cat ? "active" : ""}`}
                  >
                    {cat === "ALL" ? "Tümü" : cat}
                  </button>
                ))}
              </div>

              {/* Search Box */}
              <div className="list-search">
                <Search />
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="İşletme veya hizmet ara..."
                />
              </div>
            </div>

            {/* Business Grid */}
            {filtered.length > 0 ? (
              <div className="business-grid">
                {filtered.map((business) => (
                  <BusinessCard key={business.id} business={business} />
                ))}
              </div>
            ) : (
              <div className="empty-state">
                Aramanıza uygun işletme bulunamadı.
              </div>
            )}
          </>
        )}
      </section>
    </div>
  );
}
